import axiosInstance from './axiosInstance';

export async function getLoads(page = 1, limit = 10) {
  const response = await axiosInstance.get('/loads/get-loads.php', {
    params: { page, limit },
  });
  return response.data;
}

// Fetches a single load by its id, used on the Load Detail screen.
export async function getLoad(id) {
  const response = await axiosInstance.get(`/loads/get-load.php?id=${id}`);
  return response.data;
}


// Updates a load's status (e.g. awaiting -> picked up -> delivered).
export async function updateLoadStatus(loadId, newStatus) {
  const response = await axiosInstance.post('/loads/update-status.php', {
    load_id: loadId,
    new_status: newStatus,
  });
  return response.data;
}



export async function getAllLoads(page = 1, limit = 10, query = '') {
  const response = await axiosInstance.get('/loads/get-all-loads.php', {
    params: { page, limit, q: query },
  });
  return response.data;
}




export async function getActiveLoads() {
  const response = await axiosInstance.get('/loads/get-active-loads.php');
  return response.data;
}